import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class ServerUtilRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  getDatabaseTime(): Observable<string> {
    const endpointUrl = `util/database-time`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }
}
